import styled from 'styled-components';

import { Modal } from 'src/components/core';
import { StyledFlexContainer } from 'src/components/core/layout/FlexContainer';

export const PairInfoName = styled(StyledFlexContainer)`
    ${({ theme: { colors, typography } }) => `
        & > div {
            & > span {
                font-size: ${typography.size.mobile.heading.h5};
                line-height: calc(${typography.lineHeight[5]} + 0.5px);
                font-weight: ${typography.weight.medium};
                color: ${colors.text.tertiary};
                margin-right: 8px;
                & > span {
                    color: ${colors.text.primary};
                }
            }
            & > svg {
                margin-right: 8px;
            }
        }
        & > svg {
            margin-left: 8px;
            width: 14px;
            height: 14px;
        }
    `}
`;
export const PairInfoOperationIcon = styled(StyledFlexContainer)`
    & > svg {
        margin-left: 10px;
        width: 20px;
        height: 20px;
    }
`;

export const PairListIndex = styled.ul`
    ${({ theme: { colors, typography } }) => `
        & > li:nth-of-type(1) {
            display: flex;
            align-items: center;
            & > div {
                &:nth-of-type(1) {
                    font-size: ${typography.size.mobile.heading.h1};
                    line-height: calc(${typography.lineHeight[13]} - 0.5px);
                    font-weight: ${typography.weight.medium};
                    margin-bottom: 4px;
                }
                &:nth-of-type(2) {
                    max-width: 34px;
                    height: 16px;
                    font-size: ${typography.size.desktop.paragraph.p3};
                    line-height: ${typography.lineHeight[2]};
                    font-weight: ${typography.weight.medium};
                    border: 1px solid ${colors.primary};
                    overflow: hidden;
                    border-radius: 2px;
                    display: flex;
                    align-items: center;
                    margin-left: 4px;
                    padding: 0 2px;
                    text-align: center;
                }
            }
        }
        & > li:nth-of-type(2) {
            font-size: ${typography.size.mobile.heading.h7};
            line-height: calc(${typography.lineHeight[3]} - 0.5px);
            color: ${colors.text.tertiary};
            & > span {
                margin-left: 8px;
                @media (max-width: 335px) {
                    margin-left: 4px;
                }
            }
        }
    `}
`;

export const PairListIInfo = styled.ul`
    ${({ theme: { colors, typography } }) => `
        font-size: ${typography.size.mobile.paragraph.p2};
        line-height: ${typography.lineHeight[4]};
        &:nth-of-type(1) {
            margin-right: 20px;
            color: ${colors.text.tertiary};
            @media (max-width: 335px) {
                margin-right: 4px;
            }
        }
        &:nth-of-type(2) {
            text-align: end;
        }
    `}
`;
export const CoinInfoModal = styled(Modal)`
    & .modal-paper {
        width: 328px;
        height: 435px;
        & .modal-content {
            & span {
                width: 100%;
            }
        }
    }
`;
